// UI related
const BEGIN_USER_DETAILS_LOADING = "BEGIN_USER_DETAILS_LOADING"
const FINISH_USER_DETAILS_LOADING = "FINISH_USER_DETAILS_LOADING"
const RECEIVE_USER_DETAILS = "RECEIVE_USER_DETAILS";



export default {
  BEGIN_USER_DETAILS_LOADING,
  FINISH_USER_DETAILS_LOADING,
  RECEIVE_USER_DETAILS,
};
